import type { SpacesConfig, SpaceTemplate } from 'feature/editorial-dash/spaces';
import type { Feature } from 'util/stdtypes';
import { t } from 'util/stdtypes';

export const AudienceInputTemplate: SpaceTemplate = {
    key: 'audience-input',
    label: t('Audience Input'),
    description: t('Collect questions, testimonials, and stories from users. This allows for a greater range of engagement.'),
    imageUrl: 'images/audience-input.svg',
    structureKey: 'question',
    featuresEnabled: ['upvote', 'multi-answer', 'poll-question', 'pin_reply', 'most-popular'],
    featuresDisabled: ['reactiontypes', 'top-tab'],
    featuresHidden: ['top-tab'],
};

export const AudienceInputTemplateFeature: Feature<SpacesConfig, {}> = {
    key: 'audience-input-template',
    name: 'Audience Input Template',
    dev: true,
    providesConfig: {
        templates: [AudienceInputTemplate],
    },
};
